export const reactAdmin = {
  ra: {
    action: {
      add: '新增',
      back: '返回',
      bulk_actions: '選擇了 %{smart_count} 項',
      cancel: '取消',
      clear_input_value: '清除值',
      clone: '複製',
      confirm: '確認',
      create: '新建',
      delete: '刪除',
      edit: '編輯',
      export: '匯出',
      list: '列表',
      refresh: '重新整理',
      remove: '移除',
      save: '儲存',
      search: '搜尋',
      actions: '操作',
      show: '檢視',
      sort: '排序',
      undo: '復原',
      unselect: '取消選擇',
      expand: '展開',
      close: '關閉',
      open_menu: '開啟選單',
      close_menu: '關閉選單',
      add_filter: '新增篩選',
      remove_filter: '移除此篩選',
      remove_all_filters: '移除所有篩選',
      clear_array_input: '清空列表',
      create_item: '新建 %{item}',
      select_all: '全選',
      select_all_button: '全選',
      select_row: '選擇此行',
      select_item: '選擇項目',
      move_up: '上移',
      move_down: '下移',
      open: '開啟',
      toggle_theme: '切換淺色/深色模式',
      select_columns: '欄位',
      update_application: '重新載入應用程式',
      update: '更新',
    },
    boolean: {
      true: '是',
      false: '否',
      null: ' ',
    },
    page: {
      create: '新建 %{name}',
      dashboard: '儀表板',
      edit: '%{name} #%{id}',
      error: '發生錯誤',
      list: '%{name}',
      loading: '載入中',
      not_found: '找不到頁面',
      show: '%{name} #%{id}',
      empty: '還沒有 %{name}',
      invite: '要新增一個嗎？',
      access_denied: '拒絕存取',
      authentication_error: '認證錯誤',
    },
    input: {
      file: {
        upload_several: '拖曳檔案到這裡，或點擊選擇檔案。',
        upload_single: '拖曳檔案到這裡，或點擊選擇檔案。',
      },
      image: {
        upload_several: '拖曳圖片到這裡，或點擊選擇圖片。',
        upload_single: '拖曳圖片到這裡，或點擊選擇圖片。',
      },
      references: {
        all_missing: '找不到參考資料。',
        many_missing: '至少有一個相關參考資料不再可用。',
        single_missing: '相關參考資料不再可用。',
      },
      autocomplete: {
        no_options: '無選項',
        loading: '載入中...',
      },
      password: {
        toggle_visible: '隱藏密碼',
        toggle_hidden: '顯示密碼',
      },
    },
    message: {
      about: '關於',
      are_you_sure: '您確定嗎？',
      choose: '請選擇',
      bulk_delete_content: '您確定要刪除這 %{name} 嗎？ |||| 您確定要刪除這 %{smart_count} 項嗎？',
      bulk_delete_title: '刪除 %{name} |||| 刪除 %{smart_count} 個 %{name}',
      delete_content: '您確定要刪除這項目嗎？',
      delete_title: '刪除 %{name} #%{id}',
      details: '詳情',
      error: '發生客戶端錯誤，您的請求無法完成。',
      invalid_form: '表單無效。請檢查錯誤',
      loading: '頁面正在載入，請稍候',
      no: '否',
      not_found: '您輸入了錯誤的網址，或者點擊了無效的連結。',
      yes: '是',
      unsaved_changes: '您的一些更改未儲存。您確定要忽略它們嗎？',
      access_denied: '您沒有存取此頁面的權限',
      authentication_error: '認證伺服器回傳了錯誤，無法驗證您的憑證。',
      auth_error: '驗證認證權杖時發生錯誤。',
      bulk_update_content: '您確定要更新此 %{name} %{recordRepresentation}嗎？ |||| 您確定要更新這 %{smart_count} 項嗎？',
      bulk_update_title: '更新 %{name} %{recordRepresentation} |||| 更新 %{smart_count} %{name}',
      clear_array_input: '您確定要清空整個列表嗎？',
      placeholder_data_warning: '網路問題：資料重新整理失敗。',
      select_all_limit_reached: '元素太多無法全部選擇。只選擇了前 %{max} 個元素。',
    },
    navigation: {
      no_results: '找不到結果',
      no_more_results: '頁碼 %{page} 超出範圍。請嘗試上一頁。',
      page_out_of_boundaries: '頁碼 %{page} 超出範圍',
      page_out_from_end: '無法翻到最後一頁之後',
      page_out_from_begin: '無法翻到第1頁之前',
      page_range_info: '%{offsetBegin}-%{offsetEnd} / %{total}',
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} / 超過 %{offsetEnd}',
      page_rows_per_page: '每頁行數：',
      next: '下一頁',
      previous: '上一頁',
      page: '前往第 %{page} 頁',
      first: '第一頁',
      last: '最後一頁',
      current_page: '第 %{page} 頁',
      skip_nav: '跳到內容',
      clear_filters: '清除篩選器',
      no_filtered_results: '使用當前篩選器找不到 %{name}。',
    },
    sort: {
      sort_by: '按 %{field_lower_first} %{order} 排序',
      ASC: '升序',
      DESC: '降序',
    },
    auth: {
      auth_check_error: '請登入以繼續',
      user_menu: '個人設定',
      username: '使用者名稱',
      password: '密碼',
      email: '電子郵件',
      sign_in: '登入',
      sign_in_error: '驗證失敗，請重試',
      logout: '登出',
    },
    notification: {
      updated: '項目已成功更新 |||| %{smart_count} 個項目已成功更新',
      created: '項目已成功建立',
      deleted: '項目已成功刪除 |||| %{smart_count} 個項目已成功刪除',
      bad_item: '項目不正確',
      item_doesnt_exist: '項目不存在',
      http_error: '伺服器通訊錯誤',
      data_provider_error: '資料提供者錯誤。請檢查控制台以獲取詳情。',
      i18n_error: '無法載入指定語言的翻譯',
      canceled: '操作已取消',
      logged_out: '您的會話已結束，請重新連線。',
      not_authorized: '您無權存取此資源。',
      application_update_available: '有新版本可用。',
    },
    validation: {
      required: '必填',
      minLength: '必須至少 %{min} 個字元',
      maxLength: '必須最多 %{max} 個字元',
      minValue: '必須至少為 %{min}',
      maxValue: '必須最多為 %{max}',
      number: '必須是數字',
      email: '必須是有效的電子郵件',
      oneOf: '必須是其中之一：%{options}',
      regex: '必須符合特定格式（正規表達式）：%{pattern}',
      unique: '必須是唯一的',
    },
    saved_queries: {
      label: '已儲存的查詢',
      query_name: '查詢名稱',
      new_label: '儲存當前查詢...',
      new_dialog_title: '儲存當前查詢為',
      remove_label: '移除已儲存的查詢',
      remove_label_with_name: '移除查詢 "%{name}"',
      remove_dialog_title: '移除已儲存的查詢？',
      remove_message: '您確定要從已儲存查詢列表中移除此項目嗎？',
      help: '篩選列表並儲存此查詢以供日後使用',
    },
    configurable: {
      customize: '自訂',
      configureMode: '設定此頁面',
      inspector: {
        title: '檢查器',
        content: '將滑鼠懸停在應用程式 UI 元素上以設定它們',
        reset: '重設設定',
        hideAll: '隱藏全部',
        showAll: '顯示全部',
      },
      Datagrid: {
        title: '資料網格',
        unlabeled: '未標記的欄位 #%{column}',
      },
      SimpleForm: {
        title: '表單',
        unlabeled: '未標記的輸入 #%{input}',
      },
      SimpleList: {
        title: '列表',
        primaryText: '主要文字',
        secondaryText: '次要文字',
        tertiaryText: '第三文字',
      },
    },
  },
};